export const snippet = `<script src="https://cdn.jsdelivr.net/npm/mereos@1.1.9/dist/mereos.min.js"></script>`;

export const CdnInitFunction = `var token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9...';

var candidate_object = {
    type: 'candidate',
    name: 'John Doe',
    email: 'john.doe@gmail.com',
    phone: '+613324234',
    external_id: 'ui11223',
    school: 1999999,
    ...
};

var profile_id = 33212214;

var assessment_object = {
    name: 'Geology',
    external_id: '3235235235' 
    ...
};

var theme_object ={
    language: 'es',
    theming: '#000000',
    mode:'dark'
    ...
};

window.Mereos.init(token, candidate_object, profile_id, assessment_object, theme_object, callback);`

export const NpmInitFunction = `var { init } = require('mereos');

var token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9...';

var candidate_object = {
    type: 'candidate',
    name: 'John Doe',
    email: 'john.doe@gmail.com',
    phone: '+613324234',
    external_id: 'ui11223',
    school: 1999999,
    ...
}
var profile_id = 33212214;

var assessment_object = {
    name: 'Geology',
    external_id: '3235235235' 
    ...
}
var theme_object = {
    language: 'es',
    theming: '#000000',
    mode:'dark'
    ...
}

init(token, candidate_object, profile_id, assessment_object, theme_object, callback);`

export const startPrecheck = `window.Mereos.start_prechecks(callback,'session_resume');`

export const npmStartPrecheck = `var { start_prechecks } = require('mereos');
start_prechecks(callback,'session_resume');`

export const stopPrecheck = `window.Mereos.stop_prechecks(callback);`

export const npmStopPrecheck = `var { stop_prechecks } = require('mereos');
stop_prechecks(callback);`

export const startSessions = `window.Mereos.start_session(callback);`
export const npmStartSessions = `var { start_session } = require('mereos');
start_session(callback);`

export const stopSessions = `window.Mereos.stop_session(callback);`
export const npmStopSessions = `var { stop_session } = require('mereos');
stop_session(callback);`

export const packageType = {
	npm: `npm install mereos`,
	yarn: `yarn add mereos`,
	pnpm: `pnpm add mereos`
}

export const recordingEntitties = [
	{
		description: "recording_options_desc",
		name: 'recording_options',
		key: 'recording',
		overview: {
			name: 'recording_settings_overview',
			description: 'the_recording_settings_in_mereos_offer'
		},
		entityDescription: [
			{
				heading: 'record_video',
				description: 'record_video_desc'
			},
			{
				heading: 'record_audio',
				description: 'record_audio_desc'
			},
			{
				heading: 'record_screen',
				description: 'record_screen_desc'
			},
			{
				heading: 'record_room',
				description: 'record_room_desc'
			},
			{
				heading: 'mobile_proctoring',
				description: 'mobile_proctoring_desc'
			}
		],
		entities: [
			{
				counter_dependency: [],
				dependency: [],
				entity_group: 2,
				description: "record_video_entity_desc",
				name: 'record_video',
				id: 1,
				image: 'https://mereos-extension.s3.eu-west-3.amazonaws.com/proctoring-icons/recordVideo_47LCXwP.svg',
				key: 'record_video'
			},
			{
				counter_dependency: [],
				dependency: [],
				entity_group: 2,
				description: "track_location_entity_desc",
				name: 'track_location',
				id: 1,
				image: 'https://mereos-corder.s3.amazonaws.com/proctoring-icons/trackLocation_XyyfTvt.svg',
				key: 'track_location'
			},
			{
				counter_dependency: [],
				dependency: [],
				entity_group: 2,
				description: "record_room_entity_desc",
				name: 'record_room',
				image: "https://mereos-extension.s3.eu-west-3.amazonaws.com/proctoring-icons/recordingOptions/recordRoom.svg",
				id: 2,
				key: 'record_room'
			},
			{
				counter_dependency: [],
				dependency: [],
				entity_group: 2,
				name: 'record_screen',
				description: 'record_screen_entity_desc',
				id: 49,
				key: 'record_screen',
				image: 'https://mereos-extension.s3.eu-west-3.amazonaws.com/proctoring-icons/recordingOptions/recordScreen.svg'
			},
			{
				counter_dependency: [],
				dependency: [],
				entity_group: 2,
				description: 'record_audio_entity_desc',
				image: "https://mereos-extension.s3.eu-west-3.amazonaws.com/proctoring-icons/recordingOptions/recordAudio.svg",
				name: 'record_audio',
				id: 50,
				key: 'record_audio'
			},
			{
				image: 'https://mereos-extension.s3.eu-west-3.amazonaws.com/proctoring-icons/recordVideo_47LCXwP_J2Giusj.svg',
				counter_dependency: [],
				dependency: [],
				entity_group: 2,
				name: 'mobile_proctoring',
				id: 73,
				description: 'mobile_proctoring_entity_desc',
				key: 'mobile_proctoring'
			},
		]
	},
	{
		description: "lockdown_option_desc",
		name: 'lock_down_options',
		key: 'lockdown',
		overview: {
			name: 'lockdown_and_detection_settings_overview',
			description: 'lockdown_and_detection_settings_overview_desc'
		},
		entityDescription: [
			{
				heading: 'force_full_screen',
				description: 'force_full_screen_desc'
			},
			{
				heading: 'disable_printing',
				description: 'disable_printing_desc'
			},
			{
				heading: 'disable_clipboard',
				description: 'disable_clipboard_desc'
			},
			{
				heading: 'disable_right_click',
				description: 'disable_right_click_desc'
			},
			{
				heading: 'detect_unfocus',
				description: 'detect_unfocus_desc'
			},
			{
				heading: 'camera_view',
				description: 'camera_view_desc'
			},
			{
				heading: 'notify',
				description: 'notify_desc'
			},
			{
				heading: 'force_closure',
				description: 'force_closure_desc'
			},
			{
				heading: 'detect_resizing_of_window',
				description: 'detect_resizing_of_window_desc'
			},
			{
				heading: 'disable_keyboard_shortcuts',
				description: 'disable_keyboard_shortcuts_desc'
			},
			{
				heading: 'disable_highlight_text',
				description: 'disable_highlight_text_desc'
			},
			{
				heading: 'disable_tampering',
				description: 'disable_tampering_desc'
			},
			{
				heading: 'allow_incognito_mode',
				description: 'allow_incognito_mode_desc'
			},
			{
				heading: 'pause_and_resume',
				description: 'pause_and_resume_desc'
			}
		],
		entities: [
			{
				counter_dependency: [],
				dependency: [],
				entity_group: 3,
				description: "force_full_screen_entity_desc",
				name: 'force_full_screen',
				id: 7,
				image: 'https://mereos-extension.s3.eu-west-3.amazonaws.com/proctoring-icons/lockDownOptions/forceFullScreen.svg',
				key: 'force_full_screen'
			},
			{
				counter_dependency: [],
				dependency: [],
				entity_group: 3,
				description: "disable_right_click_entity_desc",
				name: 'disable_right_click',
				image: "https://mereos-extension.s3.eu-west-3.amazonaws.com/proctoring-icons/lockDownOptions/disableRightClick.svg",
				id: 10,
				key: 'disable_right_click'
			},
			{
				counter_dependency: [],
				dependency: [],
				entity_group: 3,
				description: "detect_resizing_of_window_entity_desc",
				name: 'detect_resizing_of_window',
				image: "https://mereos-corder.s3.amazonaws.com/proctoring-icons/lockDownOptions/screen-resize.svg",
				id: 10,
				key: 'detect_resizing_of_window'
			},
			{
				image: 'https://mereos-corder.s3.amazonaws.com/proctoring-icons/disableClipboard.svg',
				counter_dependency: [],
				dependency: [],
				entity_group: 2,
				name: 'disable_clipboard',
				id: 73,
				description: 'disable_clipboard_entity_desc',
				key: 'disable_clipboard'
			},
			{
				image: 'https://mereos-corder.s3.amazonaws.com/proctoring-icons/lockDownOptions/disableRightClick.svg',
				counter_dependency: [],
				dependency: [],
				entity_group: 2,
				name: 'disable_printing',
				id: 74,
				description: 'disable_printing_entity_desc',
				key: 'disable_printing'
			},
			{
				image: 'https://mereos-corder.s3.amazonaws.com/proctoring-icons/camera-view.svg',
				counter_dependency: [],
				dependency: ['record_video'],
				entity_group: 2,
				name: 'camera_view',
				id: 73,
				description: 'camera_view_entity_desc',
				key: 'camera_view'
			},
			{
				image: 'https://mereos-corder.s3.amazonaws.com/proctoring-icons/Notify.svg',
				counter_dependency: [],
				dependency: [],
				entity_group: 2,
				name: 'notify',
				id: 73,
				description: 'notify_entity_desc',
				key: 'notify'
			},
			{
				image: 'https://mereos-corder.s3.amazonaws.com/proctoring-icons/disableRightClick_kiP9F70.png',
				counter_dependency: [],
				dependency: ['record_video', 'record_screen', 'record_audio'],
				entity_group: 2,
				name: 'force_closure',
				id: 73,
				description: 'force_closure_entity_desc',
				key: 'force_closure'
			},
			{
				image: 'https://mereos-corder.s3.amazonaws.com/proctoring-icons/lockDownOptions/unfocus.svg',
				counter_dependency: [],
				dependency: [],
				entity_group: 2,
				name: 'detect_unfocus',
				id: 73,
				description: 'detect_unfocus_entity_desc',
				key: 'detect_unfocus'
			},
			{
				image: 'https://mereos-corder.s3.amazonaws.com/proctoring-icons/disableKeyboardShortcuts_qDooKSV.svg',
				counter_dependency: [],
				dependency: ['disable_clipboard'],
				entity_group: 2,
				name: 'disable_keyboard_shortcuts',
				id: 73,
				description: 'disable_keyboard_shortcuts_entity_desc',
				key: 'disable_keyboard_shortcuts'
			},
			{
				image: 'https://mereos-corder.s3.amazonaws.com/proctoring-icons/allow-incognito.svg',
				counter_dependency: [],
				dependency: [''],
				entity_group: 2,
				name: 'allow_incognito_mode',
				id: 73,
				description: 'allow_incognito_mode_desc',
				key: 'allow_incognito_mode'
			},
			{
				image: 'https://mereos-corder.s3.amazonaws.com/proctoring-icons/disable-tampering.svg',
				counter_dependency: [],
				dependency: [''],
				entity_group: 2,
				name: 'disable_tampering',
				id: 73,
				description: 'disable_tampering_desc',
				key: 'disable_tampering'
			},
			{
				image: 'https://mereos-corder.s3.amazonaws.com/proctoring-icons/disable-highlight_05zTsMl.svg',
				counter_dependency: [],
				dependency: [''],
				entity_group: 2,
				name: 'disable_highlight_text',
				id: 73,
				description: 'disable_highlight_text_desc',
				key: 'disable_highlight_text'
			},
			{
				image: 'https://mereos-corder.s3.amazonaws.com/proctoring-icons/pause-and-resume.svg',
				counter_dependency: [],
				dependency: [],
				entity_group: 2,
				name: 'pause_and_resume',
				id: 408,
				description: 'pause_and_resume_desc',
				key: 'pause_and_resume'
			},
		]
	},
	{
		description: "verification_options_desc",
		name: 'verification_options',
		key: 'verification',
		overview: {
			name: 'verification_settings_overview',
			description: 'verification_settings_overview_desc'
		},
		entityDescription: [
			{
				heading: 'verify_id',
				description: 'verify_id_desc'
			},
			{
				heading: 'verify_candidate',
				description: 'verify_candidate_desc'
			},
			{
				heading: 'verify_desktop',
				description: 'verify_desktop_desc'
			},
			{
				heading: 'verify_multiple_devices',
				description: 'verify_multiple_devices_desc'
			},
		],
		entities: [
			{
				counter_dependency: [],
				dependency: [],
				entity_group: 4,
				image: "https://mereos-corder.s3.amazonaws.com/proctoring-icons/verifyId_UU7cHsk.svg",
				name: 'verify_id',
				id: 50,
				description: 'verify_id_entity_desc',
				key: 'verify_id'
			},
			{
				counter_dependency: [],
				dependency: [],
				entity_group: 4,
				name: 'verify_candidate',
				description: 'verify_candidate',
				description: 'verify_candidate_entity_desc',
				id: 49,
				key: 'verify_candidate',
				image: 'https://mereos-corder.s3.amazonaws.com/proctoring-icons/verificationOptions/verifyVideo.svg'
			},
			{
				counter_dependency: [],
				dependency: [],
				entity_group: 4,
				description: "verify_desktop_entity_desc",
				name: 'verify_desktop',
				id: 64,
				image: 'https://mereos-extension.s3.eu-west-3.amazonaws.com/proctoring-icons/verifyDesktop_A2K6SaS.svg',
				key: 'verify_desktop'
			},
			{
				counter_dependency: [],
				dependency: [],
				entity_group: 4,
				description: "verify_multiple_devices_desc",
				name: 'verify_multiple_devices',
				id: 64,
				image: 'https://mereos-corder.s3.amazonaws.com/proctoring-icons/verifyvideo.svg',
				key: 'verify_multiple_devices'
			}
		]
	},
	{
		description: "system_option_desc",
		name: 'system_options',
		key: 'system',
		overview: {
			name: 'system_option_desc_overview',
			description: 'system_option_overview_desc'
		},
		entityDescription: [
			{
				heading: 'verify_upload_speed',
				description: 'verify_upload_speed_desc'
			},
			{
				heading: 'verify_ram',
				description: 'verify_ram_desc'
			},
			{
				heading: 'verify_download_speed',
				description: 'verify_download_speed_desc'
			},
		],
		entities: [
			{
				counter_dependency: [],
				dependency: [],
				entity_group: 4,
				image: "https://mereos-corder.s3.amazonaws.com/proctoring-icons/Notify.svg",
				name: 'verify_upload_speed',
				id: 50,
				description: 'verify_upload_speed_desc',
				key: 'verify_upload_speed'
			},
			{
				counter_dependency: [],
				dependency: [],
				entity_group: 4,
				name: 'verify_ram',
				description: 'verify_ram_desc',
				id: 49,
				key: 'verify_ram',
				image: 'https://mereos-corder.s3.amazonaws.com/proctoring-icons/camera-view.svg'
			},
			{
				counter_dependency: [],
				dependency: [],
				entity_group: 4,
				description: "verify_download_speed_desc",
				name: 'verify_download_speed',
				id: 64,
				image: 'https://mereos-corder.s3.amazonaws.com/proctoring-icons/lockDownOptions/screen-resize.svg',
				key: 'verify_download_speed'
			}
		]
	},
	{
		description: "mereos_policy_desc",
		name: 'ai_features',
		key: 'ai',
		overview: {
			name: 'artificial_intelligence_overview',
			description: 'artificial_intelligence_overview_desc'
		},
		entityDescription: [
			{
				heading: 'multiple_people',
				description: 'multiple_people_desc'
			},
			{
				heading: 'person_missing',
				description: 'person_missing_desc'
			},
			{
				heading: 'object_detection',
				description: 'object_detection_desc'
			},
		],
		entities: [
			{
				counter_dependency: [],
				dependency: ['record_video', 'camera_view'],
				entity_group: 2,
				description: "multiple_people_entity_desc",
				name: 'multiple_people',
				id: 1,
				image: 'https://mereos-extension.s3.eu-west-3.amazonaws.com/proctoring-icons/multiple-people-in-the-screen_1.svg',
				key: 'multiple_people'
			},
			{
				counter_dependency: [],
				dependency: ['record_video', 'camera_view'],
				entity_group: 2,
				description: "person_missing_entity_desc",
				name: 'person_missing',
				image: "https://mereos-extension.s3.eu-west-3.amazonaws.com/proctoring-icons/AIOptions/no-people-in-the-screen.svg",
				id: 32,
				key: 'person_missing'
			},
			{
				counter_dependency: [],
				dependency: ['record_video', 'camera_view'],
				entity_group: 2,
				name: 'object_detection',
				description: 'object_detection_entity_desc',
				id: 49,
				key: 'object_detection',
				image: 'https://mereos-extension.s3.eu-west-3.amazonaws.com/proctoring-icons/AIOptions/object-detected.svg'
			},
		]
	},
	{
		description: "in_quiz_tools_desc",
		name: 'in_quiz_tools',
		key: 'quiz-tools',
		overview: {
			name: 'in_quiz_tools_overview',
			description: 'in_quiz_tools_overview_desc'
		},
		entityDescription: [
			{
				heading: 'chat_bot',
				description: 'chat_bot_desc'
			},
			{
				heading: 'live_chat',
				description: 'live_chat_desc'
			}
		],
		entities: [
			{
				counter_dependency: ['live_chat'],
				dependency: [],
				entity_group: 2,
				description: "chat_bot_entity_desc",
				name: 'chat_bot',
				id: 1,
				image: 'https://mereos-corder.s3.amazonaws.com/proctoring-icons/inQuizTools/whiteboard.svg',
				key: 'chat_bot'
			},
			{
				counter_dependency: ['chat_bot'],
				dependency: [],
				entity_group: 2,
				description: "live_chat_entity_desc",
				name: 'live_chat',
				id: 1,
				image: 'https://mereos-corder.s3.amazonaws.com/proctoring-icons/comment.png',
				key: 'live_chat'
			},
		]
	},
]